export function normalizeUid(uid: string) {
  return uid.toLowerCase().replace(/[-{}]/g, '');
}
